import SEO from "@/components/SEO";
import WaitlistForm from "@/components/WaitlistForm";
import { Mail, FileText, Sparkles } from "lucide-react";

export default function Newsletter() {
    return (
        <main data-testid="newsletter-page" className="text-white pt-32 pb-24">
            <SEO
                title="Join Purposeful | Purposeful, Inc."
                description="Get the best ideas from the founders we're speaking with, new founder stories and occasional opportunities from the Purposeful ecosystem. One useful email a month."
                path="/join"
                keywords="join Purposeful, Purposeful Inc newsletter, founder ecosystem community, impact founder network"
                schema={{
                    "@context": "https://schema.org",
                    "@type": "WebPage",
                    "url": "https://purposeful.inc/newsletter",
                    "name": "Join the Waitlist: Purposeful, Inc.",
                    "description": "Early access to the book and the writing behind it.",
                    "isPartOf": { "@id": "https://purposeful.inc/#website" },
                    "potentialAction": {
                        "@type": "SubscribeAction",
                        "target": "https://purposeful.inc/newsletter"
                    }
                }}
                breadcrumbs={[{ name: "Home", path: "/" }, { name: "Newsletter", path: "/newsletter" }]}
            />

            <section className="container-x mx-auto max-w-3xl text-center">
                <div className="overline mb-4">Join Purposeful</div>
                <h1 className="font-display text-5xl md:text-6xl font-semibold tracking-tight">
                    Stay close to<br />
                    <span className="text-[#D4AF37]">Purposeful.</span>
                </h1>
                <p className="mt-6 text-zinc-300 text-lg leading-relaxed">
                    Get the best ideas from the founders we're speaking with,
                    new founder stories and occasional opportunities from the
                    Purposeful ecosystem.
                </p>

                <div className="mt-10">
                    <WaitlistForm source="join-page" testIdPrefix="join-waitlist" />
                </div>
                <p className="mt-4 text-xs text-zinc-500 font-mono uppercase tracking-widest">
                    One useful email a month · No noise · Unsubscribe anytime
                </p>

                <div className="mt-16 grid sm:grid-cols-3 gap-6 text-left">
                    {[
                        { icon: FileText, t: "Founder interviews", d: "Snippets you won't see in the final book." },
                        { icon: Sparkles, t: "Early book excerpts", d: "Chapter previews before they're public." },
                        { icon: Mail, t: "Private essays", d: "Less polished, more honest writing from the road." },
                    ].map((c, i) => (
                        <div key={i} className="card-dark p-7" data-testid={`newsletter-perk-${i}`}>
                            <c.icon size={18} className="text-[#D4AF37]" />
                            <h3 className="font-display text-lg mt-4">{c.t}</h3>
                            <p className="text-zinc-400 text-sm mt-2">{c.d}</p>
                        </div>
                    ))}
                </div>
            </section>
        </main>
    );
}
